module.exports = __webpack_public_path__ + "img/header-memoireRingsSignature.d77a7f3.jpg";